export enum Communications_Kind
{
    Call = 0,
    SMS = 1,
    Mail = 2,
    Telegram_Msg = 3,
    Telegram_Contact = 4,
    Telegram_Callback = 5,
    PrintColor = 6,
    PrintBlackWhite = 7,
    Scan = 8,
    Copy = 9,
    Push = 10,
    Unknown = 99
}

export enum Communications_InOut {
    In = 0,
    Out = 1
}

export enum Communications_Result{
    Starting = 0,
    Sended = 1,
    SendFailed = 2,
    Received = 3,
    CallStarted = 4,
    CallEndedWithResponse = 5,
    CallEndedWithoutResponse = 6,
    CallEndedWithResponseFalse = 7,
    ReceivedLater = 8
}